import { render, staticRenderFns } from "./DataTableDetail.vue?vue&type=template&id=5d5d0d11&"
import script from "./DataTableDetail.vue?vue&type=script&lang=js&"
export * from "./DataTableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports